import { openContextModal } from "@mantine/modals";
import { getI18n } from "react-i18next";

import { ReportIssueModalInnerProps } from "./ReportIssueModal";

export const openReportIssueModal = (innerProps: ReportIssueModalInnerProps) => {
	openContextModal({
		modal: "reportIssue",
		innerProps,
		withCloseButton:false,
		radius: "xl"


	});
};
